import { BuyCreditsModal } from "@/components/credits/BuyCreditsModal";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_dashboard/settings/_admin/subscription/_subscription/add-credits",
)({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    if (!context.appConfiguration.features.canUpgradeCreditTier)
      throw redirect({
        to: "..",
        replace: true,
      });
  },
});

function RouteComponent() {
  const navigate = Route.useNavigate();

  return (
    <div className="h-full px-14 pb-12">
      <BuyCreditsModal
        className="h-full"
        onClose={() =>
          navigate({
            to: "..",
          })
        }
        onSuccess={() =>
          navigate({
            to: "..",
          })
        }
        allowPrepaidCredits={true}
      />
    </div>
  );
}
